import { type NavigationPane } from 'src/utils/navigation/navigation.types';

interface NavTab {
  label: string;
  icon: string;
}

export const NAV_TABS: Record<NavigationPane, NavTab> = {
  home: { label: 'Home', icon: 'home' },
  inbox: { label: 'Inbox', icon: 'inbox' },
  search: { label: 'Search', icon: 'search' },
  sidekick: { label: 'Sidekick', icon: 'sparkles' },
  settings: { label: 'Settings', icon: 'settings' },
};
